import { templateA } from './templateA';
import { templateB } from './templateB';
import { templateC } from './templateC';

export type LayoutMode = 'mafengwo' | 'damao' | 'business';

export interface ThemeTemplate {
  id: 'A' | 'B' | 'C';
  name: string;
  description: string;
  /** 布局模式：决定前端整体排版和交互风格 */
  layoutMode: LayoutMode;
  /** 品牌标语 */
  tagline: string;
  primary: string;
  accent: string;
  background: string;
  secondary: string;
  textPrimary: string;
  textSecondary: string;
  heroGradient: string;
  cardBg: string;
  cardBorderRadius: number;
  buttonBorderRadius: number;
  buttonStyle: 'rounded' | 'square' | 'pill';
  fontFamily: string;
  navBg: string;
  navText: string;
  footerBg: string;
  footerText: string;
  preview: {
    primary: string;
    accent: string;
    background: string;
  };
}

export const TEMPLATES: Record<string, ThemeTemplate> = {
  A: templateA,
  B: templateB,
  C: templateC,
};

export const DEFAULT_TEMPLATE = 'A';

export function getActiveTemplate(): ThemeTemplate {
  if (typeof window === 'undefined') return templateA;
  const stored = localStorage.getItem('tj_theme_template');
  return stored && TEMPLATES[stored] ? TEMPLATES[stored] : templateA;
}

export function setActiveTemplate(id: 'A' | 'B' | 'C'): void {
  localStorage.setItem('tj_theme_template', id);
}
